import { atom } from "recoil";
import { FilterDef } from "../../../constants/FinanceModels";

// The state for requesting an update on Royalties' reports table
export const STATE_REPORT_UPDATING = atom<boolean>({
    key: "state-report-updating",
    default: false
});

// The state for requesting an update on Royalties' printouts table
export const STATE_PRINTOUT_UPDATING = atom<boolean>({
    key: "state-printout-updating",
    default: false
});

// The state of active filters on Royalties' reports page
export const STATE_REPORT_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'state-report-active-filters',
    default: []
});

// The state of active filters on Royalties' printouts page
export const STATE_PRINTOUT_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'state-printout-active-filters',
    default: []
});

export const STATE_REPORT_TOTAL_COUNT = atom<any>({
    key: 'state-report-total-count',
    default: null
});

export const STATE_PRINTOUT_TOTAL_COUNT = atom<any>({
    key: 'state-printout-total-count',
    default: null
});

export const STATE_DISABLE_TAB = atom<boolean>({
    key: "royalties-state-tab-disable",
    default: false
});